// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2Snfr","messages":"Chat_messages__28koc","dateDivider":"Chat_dateDivider__1cUxG"};